import styled from 'styled-components'

export const AnswerInputGroupUi = styled.div<{ flexBasis?: number }>`
  ${p => p.flexBasis && `flex-basis: ${p.flexBasis}px`}
`
